var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 9.44953C-0.097631 9.05901 -0.0976315 8.42584 0.292893 8.03532L7.73529 0.592922C7.74863 0.579584 7.76225 0.566701 7.77613 0.554274L8.03742 0.292985C8.42795 -0.0975387 9.06111 -0.0975388 9.45164 0.292985L16.9036 7.7449C17.2941 8.13543 17.2941 8.76859 16.9036 9.15912L15.9438 10.1188C15.5533 10.5094 14.9201 10.5094 14.5296 10.1188L8.74343 4.33265L2.66683 10.4093C2.27631 10.7998 1.64314 10.7998 1.25262 10.4093L0.292893 9.44953Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.91877b5c68ce67a8ccd7a789a6ca3b3a.svg";
export { ForwardRef as ReactComponent };